import React from 'react';
import { Box, Grid, Container } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import * as Scroll from "react-scroll";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import { colors } from "../theme";

export const Footer: React.FC<{}> = () => {
    const classes = useStyles({});

    return (
        <div className={classes.root}>
            <Container>
                <div className={classes.topOuter}>
                    <div className={classes.topInner} onClick={() => Scroll.animateScroll.scrollToTop()}>
                        <KeyboardArrowUpIcon className={classes.chevron} />
                    </div>
                </div>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={7}>
                        <h5 className={classes.title}><span>RB Elektropráce</span></h5>
                        <p className="pb-1">
                            Provádíme návrhy a realizace elektrorozvodů a rozvaděčů. Připrávíme návrh i cenovou kalkulaci. Provádíme také realizace  průmyslové rozvodů, montáže centrálních vysavačů. Rekonstrukce hromosvodů nebo návrh a instalacace nových.
                    </p>

                    </Grid>
                    <Grid item sm={6} md={2} >
                        <h5 className={classes.title}><span>Naši partneři</span></h5>
                        <a href="https://nizke-napeti.cz.abb.com/" target="_blank" rel="noopener noreferrer">ABB</a><br />
                        <a href="https://www.legrand.cz/" target="_blank" rel="noopener noreferrer">Legrand</a> <br />
                        <a href="http://www.vypinac.cz/" target="_blank" rel="noopener noreferrer">Schneider</a><br />
                        <a href="https://www.jablotron.com/cz/" target="_blank" rel="noopener noreferrer">Jablotron</a><br />
                        <a href="https://www.hikvision.com/cz/" target="_blank" rel="noopener noreferrer">Hikvision</a><br />
                        <br />

                    </Grid>
                    <Grid item sm={6} md={3}>
                        <h5 className={classes.title}><span>Provozovatel</span></h5>
                        <address>
                            RB Elektropráce<br />
                        Luková 42<br />
                        Česká Republika<br />
                        IČO 080 61 661
                    </address>
                    </Grid>
                </Grid>



            </Container>
            <Box display="flex" className={classes.social} justifyContent="center">
                <Box display="flex" flexDirection="column" className={classes.socialLink} justifyContent="center" justifyItems="center" alignItems="center">
                    <MailIcon className={classes.phoneIcon} />
                    <a href="mailto://rb.elektroprace@seznam.cz">rb.elektroprace@seznam.cz</a>
                </Box>
                <Box display="flex" flexDirection="column" className={classes.socialLink} justifyContent="center" justifyItems="center" alignItems="center">
                    <PhoneIcon className={classes.phoneIcon} />
                    <span>+420&nbsp;604&nbsp;485&nbsp;274</span>
                </Box>

            </Box>
            <div className={classes.copyright}>
                ® 2020 rb-elektroprace.cz Všechna práva vyhrazena. <span>Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></span>
            </div>
        </div>
    )
}


const useStyles = makeStyles(() => ({
    root: {
        marginTop: 25,
        zIndex: 10,
        background: colors.footer.bgColor,
        position: "relative",
        fontSize: "1.0em",
        color: colors.footer.color,
        fontFamily: "oswald-light",
        fontWeight: 300,
        "& a": {
            color: colors.footer.link.color,
            textDecoration: "none",
        },
        "& a:hover": {
            textDecoration: "underline",
            color: colors.footer.link.hoverColor,
        }
    },
    social: {
        color: "#666",
        marginTop: 30,
    },
    socialLink: {
        margin: "0 40px",
        width: 100,
        "& span": {
            color: colors.footer.color,
        }
    },
    smallLogo: {

    },

    world: {

        position: "absolute",
        height: 140,
        bottom: 0,
    },
    title: {
        marginBottom: 15,
        "& span": {
            borderBottom: "1px dotted white",
            fontSize: "1.5em",
        },
        fontWeight: 300
    },
    topInner: {
        borderRadius: "20px",
        color: colors.footer.bgColor,
        backgroundColor: colors.footer.chevron.bgColor,
        height: "40px",
        width: "40px",
        position: "relative",
        //paddingLeft: "9px",
        lineHeight: "40px",
        borderColor: "rgba(66, 69, 66, 0.7)",
        borderWidth: "1px",
        borderStyle: "solid",
        cursor: "pointer",
        marginLeft: 4,
        top: 4,



        "&:hover": {
            backgroundColor: colors.footer.chevron.hoverColor,
            cursor: "pointer",
        },
    },

    topOuter: {
        borderRadius: "25px",
        color: "rgb(66, 69, 66)",
        backgroundColor: colors.footer.chevron.ringColor,
        height: "50px",
        width: "50px",
        position: "relative",
        left: "50%",
        marginLeft: "-25px",
        marginTop: "-25px",
        top: "-25px",

        i: {
            fontSize: "20px",
        }
    },

    chevron: {
        fontSize: "34px",
        marginLeft: 2,
        marginTop: "3px",
    },
    copyright: {
        textAlign: "center",
        color: colors.footer.copyright.color,
        lineHeight: "28px",
        width: "100%",
        backgroundColor: colors.footer.copyright.bgColor,
        fontSize: "1em",
        marginTop: 30,

        "& a": {
            color: colors.footer.copyright.link.color,
            textDecoration: "none",
        },
        "& a:hover": {
            color: colors.footer.copyright.link.hoverColor,
            textDecoration: "none",
        }
    },
    mailIcon: {
        verticalAlign: "middle",
        marginRight: "15px",
        fontSize: 50,
        padding: 5,

    },
    phoneIcon: {
        marginRight: "10px",
        padding: 5,
        //backgroundColor: colors.footer.copyright.icon.bgColor,
        verticalAlign: "middle",
        fontSize: 50,


    },

}));


// WEBPACK FOOTER //
// ./src/layout/Footer.tsx